Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.YoutubeVideoParser

  parse: (rawVideo) ->
    @rawVideo = rawVideo
    id = @rawVideo.id
    channelId = @rawVideo.channelId
    channelName = @rawVideo.channelName
    channelThumbnail = @rawVideo.channelThumbnail
    categoryId = @rawVideo.categoryId
    title = @rawVideo.title
    description = @rawVideo.description
    duration = @rawVideo.duration
    defaultLanguage = @rawVideo.defaultLanguage
    publishedAt = @rawVideo.publishedAt
    tags = @rawVideo.tags
    thumbnailUrlMediumRes = @rawVideo.thumbnailUrlMediumRes
    thumbnailHeightMediumRes = @rawVideo.thumbnailHeightMediumRes
    thumbnailWidthMediumRes = @rawVideo.thumbnailWidthMediumRes
    thumbnailUrlStandardRes = @rawVideo.thumbnailUrlStandardRes
    thumbnailHeightStandardRes = @rawVideo.thumbnailHeightStandardRes
    thumbnailWidthStandardRes = @rawVideo.thumbnailWidthStandardRes
    privacyStatus = @rawVideo.privacyStatus
    rawData = @rawVideo.rawData
    return new Monitoring.Models.SocialContents.YoutubeVideo(id, channelId, channelName, channelThumbnail, categoryId, title, description, duration, defaultLanguage, publishedAt, tags, thumbnailUrlMediumRes, thumbnailHeightMediumRes, thumbnailWidthMediumRes, thumbnailUrlStandardRes, thumbnailHeightStandardRes, thumbnailWidthStandardRes, privacyStatus, rawData)
